import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Popup from "reactjs-popup";
import { Toggle } from '@opendate-app/setlist';
import CSVImporter from '../../CSVImporter/CSVImporter';
import GoogleIcon from '../../shared/Icons/GoogleIcon';
import '../styles/calendarOptions.css';
const axios = require('axios').default;

import $ from 'jquery';
require('datatables.net-bs4');

const settingsContentStyle = {
  "border": "1px solid var(--sl-border-secondary, #E9EAEB)",
  "borderRadius": "12px",
  "boxShadow": "var(--sl-shadow-lg, 0 12px 16px -4px rgba(10,13,18,0.08))",
  "width": "280px",
  "padding": "0px",
  "overflow": "hidden",
  "background": "var(--sl-bg-primary, #fff)",
  "marginTop": "10px",
  "zIndex": "3000"
}

const MenuItem = ({ icon, label, onClick, href, destructive }) => (
  <a href={href || "#"}
      className={"calendar-options-item" + (destructive ? " calendar-options-item--destructive" : "")}
      onClick={onClick ? (e) => { e.preventDefault(); onClick(); } : undefined}>
    <span className="calendar-options-icon">
      {typeof icon === "string" ? <i className={icon}></i> : icon}
    </span>
    {label}
  </a>
);

const CalendarOptions = ({
  csrfToken,
  user,
  team,
  saveUserCalendarStartDay,
  currentTeamMembership,
  checkAvailsIsOpenChanged,
  calendarSyncIsOpenChanged,
  fetchCalendarEventsForSelectedVenues,
  selectedRooms,
  selectedTags,
  children,
  dataTableEl,
  dataTableFilters,
  showExportCsv,
  setShowClearHoldsPopup,
  updateTeamMembershipSetting
}) => {
  const [calendarStartDay, setCalendarStartDay] = useState(user.calendar_start_day);

  const updateTeamMembership = (csrfToken, team, teamMembership, params, onSuccess) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.patch("/teams/" + team.id + "/team_memberships/" + teamMembership.id, {
        team_membership: params
      })
      .then(({ data }) => {
        onSuccess(data);
      })
  };

  const exportCsv = () => {
    var dataTable = $(dataTableEl).DataTable();
    var url = dataTable.ajax.url().replace(/\.json$/, ".csv");
    var params = Object.assign({},
      dataTable.ajax.params(),
      dataTableFilters
    );

    window.location.href = (url + '?' + $.param(params));
  };

  const importIcs = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.ics';
    fileInput.style.display = 'none';

    fileInput.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('room_id', selectedRooms[0].value);

        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
        axios.post(`/teams/${team.id}/calendar_events/import_ics`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            alert('ICS file imported successfully!');
            fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags);
          })
          .catch(error => {
            alert(`Import failed: ${error.response?.data?.message || error.message}`);
          });
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  };

  const changeStartDay = (day) => {
    setCalendarStartDay(day);
    saveUserCalendarStartDay(csrfToken, day);
  };

  const singleRoomSelected = selectedRooms && selectedRooms.length === 1;
  const canClearHolds = setShowClearHoldsPopup && user.can_clear_holds;

  return (
    <Popup arrow={false}
            offsetY={0}
            position="bottom right"
            contentStyle={settingsContentStyle}
            overlayStyle={{ zIndex: "2999" }}
            onOpen={
              (e) => {
                e.preventDefault();
              }
            }
            trigger={children} >
      {close => (
        <div className="calendar-options">
          <div className="calendar-options-section">
            <div className="calendar-options-heading">Tools</div>
            <MenuItem icon="far fa-calendar-check"
                      label="Check avails"
                      onClick={() => { checkAvailsIsOpenChanged(true); close(); }} />
            {user.can_manage_ticket_types ? (
              <MenuItem icon="far fa-calculator"
                        label="Ticket fee calculator"
                        href="/ticket-fee-calculator" />
            ) : null}
            {showExportCsv ? (
              <MenuItem icon="far fa-download"
                        label="Export CSV"
                        onClick={() => { close(); exportCsv(); }} />
            ) : null}
          </div>
          {user.can_manage_csv_imports ? (
            <div className="calendar-options-section">
              <div className="calendar-options-heading">Import</div>
              <CSVImporter
                csrfToken={csrfToken}
                team={team}
                importerKey={"d2c8763b-a7b6-449b-add1-57e30efba507"}
                type={"CSVImportRows::CalendarEvent"}
                renderAnchor={(openModal) => (
                  <MenuItem icon="far fa-arrow-up-from-bracket" label="Events" onClick={openModal} />
                )}
                onClose={() => fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags)}
              />
              <CSVImporter
                csrfToken={csrfToken}
                team={team}
                importerKey={"78e6df50-b82c-4279-8bec-b8f2c13c1871"}
                type={"CSVImportRows::Settlement"}
                renderAnchor={(openModal) => (
                  <MenuItem icon="far fa-file-invoice-dollar" label="Settlement data" onClick={openModal} />
                )}
                onClose={() => fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags)}
              />
              {singleRoomSelected ? (
                <MenuItem icon="far fa-calendar-plus" label="ICS file" onClick={importIcs} />
              ) : null}
            </div>
          ) : null}
          <div className="calendar-options-section">
            <div className="calendar-options-heading">Calendar</div>
            <div className="calendar-options-row">
              <span id="calendar-options-week-start">Week starts on</span>
              <div className="calendar-options-segmented" role="group" aria-labelledby="calendar-options-week-start">
                {[["Sun", 0], ["Mon", 1]].map(([label, day]) => (
                  <button key={day}
                          type="button"
                          aria-pressed={calendarStartDay === day}
                          onClick={() => changeStartDay(day)}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
            {updateTeamMembershipSetting ? (
              <div className="calendar-options-row">
                <label htmlFor="team-membership-full-calendar-view-toggle">Expanded mobile view</label>
                <Toggle id="team-membership-full-calendar-view-toggle"
                        size="sm"
                        checked={!!currentTeamMembership.calendar_mobile_full_view}
                        onChange={() => {
                          updateTeamMembershipSetting({
                            calendar_mobile_full_view: !currentTeamMembership.calendar_mobile_full_view
                          });
                        }} />
              </div>
            ) : null}
            {singleRoomSelected ? (
              <MenuItem icon={<GoogleIcon />}
                        label="Sync to Google Calendar"
                        onClick={() => { calendarSyncIsOpenChanged(true); close(); }} />
            ) : null}
          </div>
          {canClearHolds ? (
            <div className="calendar-options-section">
              <MenuItem icon="far fa-trash-can"
                        label="Clear holds on a date..."
                        destructive
                        onClick={() => { setShowClearHoldsPopup(true); close(); }} />
            </div>
          ) : null}
          <div className="calendar-options-row calendar-options-footer">
            <label htmlFor="team-membership-calendar-version-toggle">New calendar</label>
            <Toggle id="team-membership-calendar-version-toggle"
                    size="sm"
                    checked={currentTeamMembership.calendar_version === "v2"}
                    onChange={() => {
                      updateTeamMembership(csrfToken, team, currentTeamMembership, {
                        calendar_version: (currentTeamMembership.calendar_version === "v2" ? "v1" : "v2")
                      }, () => {
                        location.reload();
                      });
                    }} />
          </div>
        </div>
      )}
    </Popup>
  )
};

CalendarOptions.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  saveUserCalendarStartDay: PropTypes.func.isRequired,
  currentTeamMembership: PropTypes.object.isRequired,
  checkAvailsIsOpenChanged: PropTypes.func.isRequired,
  calendarSyncIsOpenChanged: PropTypes.func.isRequired,
  fetchCalendarEventsForSelectedVenues: PropTypes.func.isRequired,
  selectedRooms: PropTypes.array,
  selectedTags: PropTypes.array,
  children: PropTypes.element,
  dataTableEl: PropTypes.object,
  dataTableFilters: PropTypes.object,
  showExportCsv: PropTypes.bool,
  setShowClearHoldsPopup: PropTypes.func,
  updateTeamMembershipSetting: PropTypes.func,
};

export default CalendarOptions;
